<template>
    <div class="root-wrap">
        <div class="body-wrap fx-fill">
            <div class="fill-box" :style="`background-color: ${'#3F4956'}`">
                <div class="fx-row fx-between fx-center">
                    <span class="order_detail-status">{{order.orderStatusText}}</span>
                    <van-icon name="delete-o" size="20" @click="confirmDelete"></van-icon>
                </div>
                <div class="order_detail-content--wrap">
                    <div class="fx-row fx-between">
                        <div class="order_detail-info fx-fill fx-column fx-between">
                            <span class="order_detail-name">{{order.moviename}}</span>
                            <div>
                                <span>{{order.playtime}}</span>
                                <span>{{order.edition}}</span>
                            </div>
                            <span>{{order.cinemaname}}</span>
                            <span class="fc-tips">{{description['影票']}}</span>
                        </div>
                        <div>
                            <van-image :src="description.logo" width="80" height="120" class="image-round"></van-image>
                        </div>
                    </div>
                    <div v-if="order.orderstatus != 'R'" class="fx-center">
                        <!-- <div>{{order.orderstatus}}</div>
                        <div>{{ticket}}</div> -->
                        <template v-if="order.orderstatus == 'S' && Object.keys(ticket).length > 0">
                            <div style="margin-bottom: 8px;">
                                <qr-code :list="ticketValue"></qr-code>
                            </div>
                        </template>
                        <template v-if="order.orderstatus == 'P' && Object.keys(ticket).length < 1">
                            <div class="order_detail-ticket fx-center">正在出票中请耐心等待...</div>
                            <div style="font-size: 12px;color: #dd6161">预计1-30分钟出票,若出票失败将为您退款</div>
                        </template>
                        <template v-else-if="order.orderstatus == 'S' && Object.keys(ticket).length > 0">
                            <div class="order_detail-ticket fx-center">
                                <div v-for="item, index in ticket" :key="index">
                                    <template v-for="temp, idx in item">
                                        <span :key="idx">
                                            <span>{{temp.name}}：</span>
                                            <span>{{temp.value}}</span>
                                        </span>
                                    </template>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="fx-around">
                        <div class="order_detail-name">{{order.cinemaname}}</div>
                        <div class="fc-tips">{{order.cinemaAddress}}</div>
                    </div>
                    <div class="fx-around">
                        <span class="order_detail-name">实付金额：￥{{order.amount}} {{order.orderstatus == 'R' ? '(已退款)' : ''}}</span>
                        <span class="fc-tips" style="padding-bottom: 5px;">订单号： {{order.tradeno}}</span>
                        <span class="fc-tips" style="padding-bottom: 5px;">下单时间： {{order.addtimelocal}}</span>
                        <span class="fc-tips" style="padding-bottom: 5px;">手机号： {{order.mobile | hideMobile}}</span>
                    </div>
                    <div class="fx-around">
                        <span class="order_detail-name">观影须知</span>
                        <p class="fc-tips">
                            1.请提前到达影院现场，找到自助取票机，打印纸质电影票，完成取票。
                            <br />2.如现场自助取票机无法打印电影票，请联系影院工作人 员处理。
                            <br />3.凭打印好的纸质电影票，检验入场观影。
                            <br />4.出票后不支持改签、退票。
                        </p>
                    </div>
                </div>
                <div class="fx-center">
                    <van-button :icon="require('@/assets/images/user/user_customer_service.png')" round @click="toCustomer">联系客服</van-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import QrCode from '@/components/qr-code'
export default {
    data() {
        return {
            tradeNo: this.$route.query.tradeNo,
            order: {},
        }
    },
    computed: {
        description() {
            return Object.keys(this.order).length > 0 ? JSON.parse(this.order.description) : {};
        },
        ticket() {
            console.log(JSON.parse(this.order.descriptionjson));
            return Object.keys(this.order).length > 0 ? JSON.parse(this.order.descriptionjson) : [];
        },
        ticketValue() {
            let ticketValue = [];
            for (let item of this.ticket) {
                if (item.length == 2) {
                    ticketValue.push(`${item[0].value}%7c${item[1].value}`)
                } else if (item.length == 1) {
                    ticketValue.push(item[0].value)
                }
            }
            return ticketValue;
        },
    },
    methods: {
        getOrderDetail() {
            this.$service.getOrderDetail({ tradeno: this.tradeNo }).then((res) => {
                this.order = res;
            })
        },
        toCustomer() {
            window.location.href = "tel:4008201350";
        },
        confirmDelete() {
            this.$dialog.confirm({
                title: '系统提示',
                message: '确认删除该订单记录吗?',
            }).then(() => {
                let loading = this.$toast.loading('删除中');
                this.$service.deleteMemberOrder({ tradeno: this.tradeNo }).then(() => {
                    loading.clear();
                    setTimeout(() => {
                        this.$goPage(-1);
                    }, 0);
                }).catch(() => {
                    loading.clear();
                })
            }).catch(() => { });
        }
    },
    mounted() {
        this.getOrderDetail();
    },
    components: {
        QrCode
    }
}
</script>

<style lang="scss" scoped>
.body-wrap {
	position: relative;
	> div {
		padding: 10px;
		> div:nth-of-type(1) {
			color: #fff;
			padding: 8px 0;
			.order_detail-status {
				font-size: 16px;
			}
		}
		.order_detail-content--wrap {
			background-color: #fff;
			border-radius: 4px;
			margin: 15px 0;
			padding: 0 20px;
			> div {
				border-bottom: 2px dashed $border-color;
				padding: 16px 0;
				.order_detail-ticket {
					border: 1px solid #dededf;
					color: $second-color;
					width: 88%;
					padding: 10px;
					font-size: 14px;
					border-radius: 4px;
					margin: 4px;
				}
			}
			.order_detail-name {
				font-size: 16px;
				font-weight: 700;
				margin-bottom: 10px;
			}
		}
	}
}
</style>
